import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { deleteEntity, updateEntities } from 'redux-modules/entity'
import api from 'api'

const CREATE_REQUEST = 'realhub/publicationCompatiblePagination/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/publicationCompatiblePagination/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/publicationCompatiblePagination/CREATE_FAILURE'
const DELETE_REQUEST = 'realhub/publicationCompatiblePagination/DELETE_REQUEST'
const DELETE_SUCCESS = 'realhub/publicationCompatiblePagination/DELETE_SUCCESS'
const DELETE_FAILURE = 'realhub/publicationCompatiblePagination/DELETE_FAILURE'

// Initial State
const initialState = {
  result: [],
  creating: false,
  deleting: false,
  errors: [],
}

// Actions
export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(payload = {}){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(payload = {}){
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators

export function deletePublicationCompatiblePagination(compatiblePagination, options){
  const config = {
    method: 'DELETE',
  }
  return (dispatch, getState) => {
    // Set Loading
    dispatch(deleteRequest())
    const url = `/admin/publications/${compatiblePagination.publication_id}/compatible_paginations/${compatiblePagination.id}.json`
    const promise = api(url, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }
        const state = getState()

        // Remove the  comapatible pagination from the publication
        const publicationEntity = Object.assign({}, state.entities.publications[compatiblePagination.publication_id])
        const compatiblePaginationIndex = publicationEntity.compatible_paginations.indexOf(compatiblePagination.id)
        publicationEntity.compatible_paginations.splice(compatiblePaginationIndex, 1)
        dispatch(updateEntities(normalize(publicationEntity, Schemas.PUBLICATION)))

        // Remove the comapatible pagination from the result array
        const publicationCompatiblePaginationArray = state.publicationCompatiblePaginations.result ? state.publicationSpecialDeadlines.result.slice() : []
        const index = publicationCompatiblePaginationArray.indexOf(compatiblePagination.id)
        const x = normalize(compatiblePagination, Schemas.PUBLICATION_COMPATIBLE_PAGINATION)
        dispatch(deleteEntity(x))

        // Remove the entity
        if (index != -1){
          publicationCompatiblePaginationArray.splice(index, 1)
          dispatch(deleteSuccess({ result: publicationCompatiblePaginationArray }))
        }
      })
      .catch((json) => {
        const errors = json.errors ? json.errors : ['Something went wrong']
        dispatch(deleteFailure(errors))
      })
    return promise
  }
}

export function createPublicationCompatiblePagination(compatiblePagination, options){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      publication_compatible_pagination: compatiblePagination,
    }),
  }

  return (dispatch, getState) => {
    // Set Loading
    dispatch(createRequest())

    const promise = api(`/admin/publications/${compatiblePagination.publication_id}/compatible_paginations.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        // Add to result array
        const resultArray = getState().publicationCompatiblePaginations.result ? getState().publicationCompatiblePaginations.result.slice() : []
        if (!resultArray.includes(json.id)){
          resultArray.push(json.id)
        }

        const normalizedJson = normalize(json, Schemas.PUBLICATION_COMPATIBLE_PAGINATION)
        const publications = Object.assign({}, getState().entities.publications)
        if (publications[compatiblePagination.publication_id]){
          const publication = publications[compatiblePagination.publication_id]
          publication.compatible_paginations.push(json.id)
          dispatch(updateEntities(normalize(publication, Schemas.PUBLICATION)))
        }
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess({ result: resultArray }))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))
      })

    return promise
  }
}
// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case CREATE_REQUEST:
      return Object.assign({}, state, {
        creating: true,
      })
    case CREATE_SUCCESS:
      return Object.assign({}, state, {
        creating: false,
        result: action.result,
        errors: [],
      })
    case CREATE_FAILURE:
      return Object.assign({}, state, {
        creating: false,
        errors: action.errors,
      })
    case DELETE_REQUEST:
      return Object.assign({}, state, {
        deleting: true,
      })
    case DELETE_SUCCESS:
      return Object.assign({}, state, {
        deleting: false,
        result: action.result,
        errors: [],
      })
    case DELETE_FAILURE:
      return Object.assign({}, state, {
        deleting: false,
        errors: action.errors,
      })
    default:
      return state
  }
}
